import React, { useEffect, useState } from "react";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { AddIconColor } from "../../../assets/images";
import "./style.scss";

type AppProps = {
  addParent: any;
  addChild: any;
  type: string;
  index: number;
  subIndex?: number;
  firstIndex?: number;
  secondIndex?: number;
  disabled?: boolean;
};

const AddParentChildBtn = ({
  addParent,
  addChild,
  type,
  index,
  subIndex,
  firstIndex,
  secondIndex,
  disabled,
}: AppProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isBtn, setIsBtn] = useState<number | null>(null);

  return (
    <ButtonDropdown
      isOpen={isOpen}
      toggle={() => {
        setIsBtn(null);
        if (!disabled) {
          setIsOpen(!isOpen);
        }
      }}
    >
      <DropdownToggle
        caret
        color="secondary"
        style={
          isOpen
            ? {
                color: "#dd4433",
                border: "1px solid #dd4433",
                backgroundColor: "#fff6f5",
              }
            : { border: "1px solid#dd4433" }
        }
        outline
      >
        <img src={AddIconColor} alt="" />
      </DropdownToggle>

      <DropdownMenu right>
        <div className="p-1" style={{ width: "150px" }}>
          <div
            className={`${isBtn === 0 ? "add-btn" : ""} add-default-btn `}
            onClick={() => {
              setIsBtn(0);
              type === "procedure"
                ? addParent()
                : type === "subheading"
                ? addParent(index)
                : type === "firstLevel"
                ? addParent(index, subIndex)
                : addChild(index, subIndex, firstIndex);
            }}
          >
            Add Parent
          </div>
          {type === "secondLevel" ? null : (
            <div
              className={`${isBtn === 1 ? "add-btn" : ""} add-default-btn mt-1`}
              onClick={() => {
                setIsBtn(1);
                type === "procedure"
                  ? addChild(index)
                  : type === "subheading"
                  ? addChild(index, subIndex)
                  : addChild(index, subIndex, firstIndex);
              }}
            >
              Add Child
            </div>
          )}
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default AddParentChildBtn;
